import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import "../../../styles/EventDetails.scss";
import { FaCalendar as FaCalendarRaw } from "react-icons/fa";
import { FaLocationDot as FaLocationDotRaw } from "react-icons/fa6";
import { IoPerson as IoPersonRaw } from "react-icons/io5";
import HeartButton from "../../../components/HeartButton";
import {
  FaShareAlt as FaShareAltRaw,
  FaFacebookF as FaFacebookFRaw,
  FaWhatsapp as FaWhatsappRaw,
  FaEnvelope as FaEnvelopeRaw,
  FaLink as FaLinkRaw,
} from "react-icons/fa";
import { useSessionContext } from "../../../security/context/SessionContext";
import { useEventRating } from "../../hooks/useEventRating";
import useShare from "../../customer/hooks/useShare";
import { FaClock as FaClockRaw } from "react-icons/fa";

interface Props {
  event_id: string;
  title: string;
  date: string[] | null;
  venue: string;
  event_rating: string;
  price: string;
  event_url?: string;
  event_slug: string;
}

const EventDetails: React.FC<Props> = ({
  event_id,
  title,
  date,
  venue,
  event_rating,
  price,
  event_url,
  event_slug,
}) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { session } = useSessionContext();
  const formattedRating = useEventRating(event_rating);

  const {
    showShareModal,
    openModal,
    closeModal,
    shareToFacebook,
    shareToMessenger,
    shareToWhatsApp,
    shareToEmail,
    copyToClipboard,
    defaultMessage,
    copySuccess,
  } = useShare();

  const handleGetTickets = () => {
    if (event_url && event_url.trim() !== "") {
      window.location.href = event_url;
      return;
    }

    if (session?.isAuthenticated) {
      navigate(`/event/${event_slug}/get-ticket`, {
      state: { eventId: event_id },
    });
    } else {
      navigate("/sec/log-in");
    }
  };

  const formatFullDate = (dateString: string) => {
    return new Date(dateString).toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  };

  const formattedDate =
    Array.isArray(date) && date.length > 0
      ? (() => {
          const sortedDates = [...date].sort(
            (a, b) => new Date(a).getTime() - new Date(b).getTime()
          );

          if (sortedDates.length === 1) {
            return formatFullDate(sortedDates[0]);
          }

          return `${formatFullDate(sortedDates[0])} - ${formatFullDate(
            sortedDates[sortedDates.length - 1]
          )}`;
        })()
      : "TBA";

  const formattedTime =
    Array.isArray(date) && date.length > 0
      ? new Date(date[0]).toLocaleTimeString("en-US", {
          hour: "numeric",
          minute: "2-digit",
          hour12: true,
        })
      : "TBA";

  const FaCalendar = FaCalendarRaw as React.ElementType;
  const FaLocationDot = FaLocationDotRaw as React.ElementType;
  const IoPerson = IoPersonRaw as React.ElementType;
  const FaShareAlt = FaShareAltRaw as React.ElementType;
  const FaFacebookF = FaFacebookFRaw as React.ElementType;
  const FaWhatsapp = FaWhatsappRaw as React.ElementType;
  const FaEnvelope = FaEnvelopeRaw as React.ElementType;
  const FaLink = FaLinkRaw as React.ElementType;
  const FaClock = FaClockRaw as React.ElementType;

  return (
    <div className="event-details">
      <div className="event-title-row">
        <h1>{title}</h1>
        {/* <HeartButton /> */}
      </div>

      <p>
        <FaCalendar className="icon" /> {formattedDate}
      </p>

      <p>
        <FaClock className="icon" /> {formattedTime}
      </p>

      <p>
        <FaLocationDot className="icon" /> {venue}
      </p>

      <p>
        <IoPerson className="icon" /> {formattedRating}
      </p>

      <div className="event-actions">
        <button className="get-ticket-btn" onClick={handleGetTickets}>
          Get Tickets
        </button>
        <button className="ep-share-button" onClick={openModal}>
          <FaShareAlt /> Share
        </button>
      </div>

      {showShareModal && (
        <div className="ep-share-modal">
          <div className="ep-share-modal-content">
            <h3>Share This Event</h3>
            <p className="p-modal">Invite your friends to buy tickets on Gottix!</p>

            <div className="ep-share-buttons">
              <button onClick={shareToFacebook} className="ep-share-option facebook">
                <FaFacebookF size={20} /> Share to Facebook
              </button>
              <button onClick={shareToWhatsApp} className="ep-share-option whatsapp">
                <FaWhatsapp size={20} /> Share via WhatsApp
              </button>
              <button
                onClick={() => shareToEmail(defaultMessage)}
                className="ep-share-option email"
              >
                <FaEnvelope size={20} /> Email
              </button>
              <button onClick={copyToClipboard} className="ep-share-option copy-link">
                <FaLink size={20} /> Copy Link
              </button>
            </div>

            {copySuccess && <p style={{ color: "green" }}>{copySuccess}</p>}

            <button onClick={closeModal} className="ep-close-modal">
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default EventDetails;